namespace RioERP.Reports {
    export interface OrderCombinedReportForm {
        OrderId: Serenity.IntegerEditor;
        OrderDate: Serenity.DateEditor;
        SourceType: Serenity.IntegerEditor;
        SourceOrderNumber: Serenity.StringEditor;
        FranchiseeName: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        City: Serenity.StringEditor;
        Address1: Serenity.StringEditor;
        Address2: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        PinCode: Serenity.StringEditor;
        ShippingAddress1: Serenity.StringEditor;
        ShippingAddress2: Serenity.StringEditor;
        ShippingCity: Serenity.StringEditor;
        ShippingPincode: Serenity.IntegerEditor;
        EOrderStatus: Serenity.IntegerEditor;
        PaymentStatus: Serenity.IntegerEditor;
        EPaymentType: Serenity.IntegerEditor;
        DiscountCoupen: Serenity.StringEditor;
        TaxableAmount: Serenity.DecimalEditor;
        Total: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmountNet: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
    }

    export class OrderCombinedReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderCombinedReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderCombinedReportForm.init)  {
                OrderCombinedReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(OrderCombinedReportForm, [
                    'OrderId', w0,
                    'OrderDate', w1,
                    'SourceType', w0,
                    'SourceOrderNumber', w2,
                    'FranchiseeName', w2,
                    'CustomerName', w2,
                    'CustomerMobile1', w2,
                    'CustomerEmail1', w2,
                    'City', w2,
                    'Address1', w2,
                    'Address2', w2,
                    'StateName', w2,
                    'PinCode', w2,
                    'ShippingAddress1', w2,
                    'ShippingAddress2', w2,
                    'ShippingCity', w2,
                    'ShippingPincode', w0,
                    'EOrderStatus', w0,
                    'PaymentStatus', w0,
                    'EPaymentType', w0,
                    'DiscountCoupen', w2,
                    'TaxableAmount', w3,
                    'Total', w3,
                    'DiscountAmount', w3,
                    'NetAmount', w3,
                    'TaxableAmountNet', w3,
                    'CgstRate', w3,
                    'CgstAmount', w3,
                    'SgstRate', w3,
                    'SgstAmount', w3,
                    'IgstRate', w3,
                    'IgstAmount', w3,
                    'TotalTax', w3
                ]);
            }
        }
    }
}
